import { ReactNode } from 'react';
import { Typography } from '../typography/typography';
import classNames from 'classnames';

export interface FilterFieldProps {
  title: string;
  titleWeight?: 'medium' | 'semi-bold';
  children: ReactNode;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
}

export const FilterField = ({
  title,
  titleWeight = 'medium',
  children,
  className,
  titleClassName,
  contentClassName,
}: FilterFieldProps) => {
  return (
    <div className={classNames('flex flex-col', className)}>
      <div className={classNames('flex flex-col justify-center', contentClassName)}>
        <div className={classNames('mt-2 mb-2', titleClassName)}>
          <Typography type="text-sm" weight={titleWeight}>
            {title}
          </Typography>
        </div>
        <div className="flex flex-wrap gap-2">{children}</div>
      </div>
    </div>
  );
};
